import { render, staticRenderFns } from "./processRecordDialog.vue?vue&type=template&id=c144405c"
import script from "./processRecordDialog.vue?vue&type=script&lang=js"
export * from "./processRecordDialog.vue?vue&type=script&lang=js"
import style0 from "./processRecordDialog.vue?vue&type=style&index=0&id=c144405c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports